import { useQuery } from "@tanstack/react-query";
import { API_STATUS } from "../apis";
import { QUERY_KEY } from "../keys";

export const useGetBookingStatus = <T>(params: { [key: string]: any }) => {
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEY.GET_STATUS, params],
        queryFn: () => API_STATUS.getBookingStatus<T>({ ...params }),
        gcTime: 0,
    });
    return { data, isLoading };
};
